import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeighingAdminModule } from './weighing-admin/weighing-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    WeighingAdminModule
  ]
})
export class WeighingModule { }
